import React from "react";
import Langing from "../components/Landing/Landing";

const LandingPage = () => {
  return (
    <div>
      <Langing />
    </div>
  );
};

export default LandingPage;
